export const Disclaimer = (props) => {
  return (
    <section className="disclaimer-section">
      <div className="disclaimer-container">
        <div className="disclaimer-content">
          <h3 className="disclaimer-title"><u>Disclaimer</u></h3>
          <div className="disclaimer-text">
            <p>
              The owner of this domain has no affiliation with third-party advertisers featured on this website. Any reference to or appearance of a particular service or trademark is not controlled by the domain owner and does not imply endorsement, association, or recommendation.
            </p>
            <p>
              Advertisements or schemes shown on this site reflect the views of the advertisers, and the domain owner is not responsible for them.
            </p>
            <p>
              Brand names, logos, videos, and registered trademarks belong to their respective owners.
            </p>
            <p>
              The information provided on this website may not be accurate. We make no guarantees regarding the validity of any claims.
            </p>
            <p>
              All images and videos on the website are the property of their respective copyright holders unless otherwise noted, and we do not claim credit for them.
            </p>
            <p>
              The content on this website is for general purposes only. We make no warranties, express or implied, about the accuracy, completeness, reliability, or suitability of the information, products, services, or related graphics on this site.
            </p>
            <p>
              We will not be liable for any loss or damage, including indirect or consequential damages, arising from the use of this website, including loss of data or profits.
            </p>
            <p>
              This website may contain links to external sites that are not controlled by the domain owner. We are not responsible for the content or availability of these external sites.
            </p>
            <p>This is not an authorized center; it is a fully private service center.</p>
          </div>
        </div>
      </div>
    </section>
  )
}